module.exports = __webpack_public_path__ + "Tinebase/js/ace-apache_conf-FAT.js";